import { render, staticRenderFns } from "./checkRiskConcern.vue?vue&type=template&id=4441c4c6&scoped=true&"
import script from "./checkRiskConcern.vue?vue&type=script&lang=js&"
export * from "./checkRiskConcern.vue?vue&type=script&lang=js&"
import style0 from "./checkRiskConcern.vue?vue&type=style&index=0&id=4441c4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4441c4c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4441c4c6')) {
      api.createRecord('4441c4c6', component.options)
    } else {
      api.reload('4441c4c6', component.options)
    }
    module.hot.accept("./checkRiskConcern.vue?vue&type=template&id=4441c4c6&scoped=true&", function () {
      api.rerender('4441c4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/checkRiskConcern.vue"
export default component.exports